<script></script>

<template>
    <footer class="fixed bottom-0 left-0 w-full border-b border-zinc-300/50 bg-white/50 backdrop-blur-sm">
        <a
            target="_blank"
            href="https://www.hexpol.com/"
        >
            <div class="mx-auto max-w-7xl px-4 py-4 text-center sm:px-6 lg:px-8">
                <p class="text-sm text-zinc-500">Hexpol.com</p>
            </div>
        </a>
    </footer>
</template>
